var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkflowsThat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7643",
    "data-name": "Group 7643",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 50.76 48.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22786",
    "data-name": "Path 22786",
    d: "M1443.48,81.216v4.258a4.757,4.757,0,0,0,1.407,3.387,4.844,4.844,0,0,0,3.4,1.4h4.28a4.8,4.8,0,0,0,4.81-4.79V81.216a4.8,4.8,0,0,0-4.81-4.79h-4.28a4.844,4.844,0,0,0-3.4,1.4A4.757,4.757,0,0,0,1443.48,81.216Zm3.207,0a1.582,1.582,0,0,1,.469-1.129,1.617,1.617,0,0,1,1.134-.468h4.28a1.618,1.618,0,0,1,1.134.468,1.585,1.585,0,0,1,.469,1.129v4.258a1.585,1.585,0,0,1-.469,1.128,1.619,1.619,0,0,1-1.134.468h-4.28a1.618,1.618,0,0,1-1.134-.468,1.582,1.582,0,0,1-.469-1.128Z",
    transform: "translate(-1426.116 -59.145)",
    fill: "#ff0185",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22787",
    "data-name": "Path 22787",
    d: "M1432,69.79v4.258a4.8,4.8,0,0,0,4.81,4.79h4.28a4.844,4.844,0,0,0,3.4-1.4,4.755,4.755,0,0,0,1.406-3.387V69.79a4.755,4.755,0,0,0-1.406-3.387,4.844,4.844,0,0,0-3.4-1.4h-4.28a4.8,4.8,0,0,0-4.81,4.79Zm3.207,0a1.584,1.584,0,0,1,.469-1.128,1.618,1.618,0,0,1,1.135-.468h4.28a1.617,1.617,0,0,1,1.135.468,1.584,1.584,0,0,1,.469,1.128v4.258a1.584,1.584,0,0,1-.469,1.128,1.618,1.618,0,0,1-1.135.468h-4.28a1.619,1.619,0,0,1-1.135-.468,1.584,1.584,0,0,1-.469-1.128Z",
    transform: "translate(-1432 -65)",
    fill: "#ff0185",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22788",
    "data-name": "Path 22788",
    d: "M1454.96,92.641V96.9a4.8,4.8,0,0,0,4.81,4.79h4.265a4.823,4.823,0,0,0,4.825-4.79V92.641a4.823,4.823,0,0,0-4.825-4.79h-4.265a4.8,4.8,0,0,0-4.81,4.79Zm3.206,0a1.582,1.582,0,0,1,.469-1.128,1.618,1.618,0,0,1,1.135-.468h4.265a1.566,1.566,0,0,1,1.135.468,1.664,1.664,0,0,1,.484,1.128V96.9a1.664,1.664,0,0,1-.484,1.128,1.567,1.567,0,0,1-1.135.468h-4.265a1.618,1.618,0,0,1-1.135-.468,1.582,1.582,0,0,1-.469-1.128Z",
    transform: "translate(-1420.233 -53.288)",
    fill: "#ff0185",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22789",
    "data-name": "Path 22789",
    d: "M1443.708,72.253h27.951a2.621,2.621,0,0,1,1.906.822,2.924,2.924,0,0,1,.786,1.984v7.856a2.924,2.924,0,0,1-.786,1.984,2.62,2.62,0,0,1-1.906.822h-6.444a1.673,1.673,0,0,0-1.134.528,1.7,1.7,0,0,0,0,2.31,1.673,1.673,0,0,0,1.134.528h6.444a5.859,5.859,0,0,0,2.284-.477,5.947,5.947,0,0,0,1.906-1.331,6.4,6.4,0,0,0,1.724-4.367V75.059a6.392,6.392,0,0,0-1.724-4.362,5.95,5.95,0,0,0-1.906-1.331,5.859,5.859,0,0,0-2.284-.477h-27.951a1.686,1.686,0,0,0,0,3.364Z",
    transform: "translate(-1426.813 -63.006)",
    fill: "#ff0185",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22790",
    "data-name": "Path 22790",
    d: "M1457.138,96.781h-19.254a2.674,2.674,0,0,1-2.677-2.661V86.668a2.673,2.673,0,0,1,2.677-2.661h11.767a1.615,1.615,0,0,0,1.134-.468,1.594,1.594,0,0,0,0-2.258,1.614,1.614,0,0,0-1.134-.468h-11.767a5.878,5.878,0,0,0-4.16,1.714A5.906,5.906,0,0,0,1432,86.668v7.452a5.906,5.906,0,0,0,1.724,4.141,5.878,5.878,0,0,0,4.16,1.714h19.254a1.552,1.552,0,0,0,1.119-.468,1.559,1.559,0,0,0,0-2.258A1.552,1.552,0,0,0,1457.138,96.781Z",
    transform: "translate(-1432 -56.896)",
    fill: "#ff0185",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22791",
    "data-name": "Path 22791",
    d: "M1461.963,86.1l-3.131-3.13,3.131-3.13a1.615,1.615,0,0,0,.439-1.117,1.657,1.657,0,0,0-.469-1.1,1.622,1.622,0,0,0-2.238-.039l-4.265,4.258a1.49,1.49,0,0,0-.348.518,1.605,1.605,0,0,0,0,1.221,1.49,1.49,0,0,0,.348.518l4.265,4.258a1.622,1.622,0,0,0,2.238-.039,1.657,1.657,0,0,0,.469-1.1A1.615,1.615,0,0,0,1461.963,86.1Z",
    transform: "translate(-1420.233 -58.771)",
    fill: "#ff0185",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22792",
    "data-name": "Path 22792",
    d: "M1449.833,99.782l4.281-4.258a1.732,1.732,0,0,0,.348-.518,1.6,1.6,0,0,0,0-1.222,1.729,1.729,0,0,0-.348-.518l-4.281-4.258a1.611,1.611,0,0,0-1.119-.428,1.577,1.577,0,0,0-1.1.467,1.6,1.6,0,0,0-.046,2.218l3.146,3.13-3.146,3.13a1.6,1.6,0,0,0,.046,2.217,1.576,1.576,0,0,0,1.1.468A1.611,1.611,0,0,0,1449.833,99.782Z",
    transform: "translate(-1424.242 -52.914)",
    fill: "#ff0185",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowsThat);
export default __webpack_public_path__ + "static/media/workflows-that.1a812c443b34a9045af0f122706d6af1.svg";
export { ForwardRef as ReactComponent };